import { render, staticRenderFns } from "./summary-product-header.vue?vue&type=template&id=a30616b2&scoped=true"
import script from "./summary-product-header.vue?vue&type=script&lang=js"
export * from "./summary-product-header.vue?vue&type=script&lang=js"
import style0 from "./summary-product-header.vue?vue&type=style&index=0&id=a30616b2&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a30616b2",
  null
  
)

export default component.exports